import layout from './layout';
import groupings from './pages/AWPM-FWPM/groupings';
import moduleSelectionLottery from './pages/AWPM-FWPM/moduleSelectionLottery';
import moduleSelections from './pages/AWPM-FWPM/moduleSelections';
import moduleSelectionsDetail from './pages/AWPM-FWPM/moduleSelectionsDetail';
import modules from './pages/AWPM-FWPM/modules';
import selectionNotifications from './pages/AWPM-FWPM/notifications';
import studentView from './pages/AWPM-FWPM/studentView';
import accessHandler from './pages/Access-Handler/accessHandler';
import entitlementGroups from './pages/Access-Handler/entitlementGroups';
import entitlements from './pages/Access-Handler/entitlements';
import permissions from './pages/Access-Handler/permissions';
import roles from './pages/Access-Handler/roles';
import activityLog from './pages/ActivityLog/activityLog';
import customer from './pages/Billing/customer';
import billingFinance from './pages/Billing/finance';
import invoice from './pages/Billing/invoice';
import settings from './pages/Billing/settings';
import eventSettings from './pages/Events/eventSettings';
import events from './pages/Events/events';
import fundingcategories from './pages/Fundings/categories';
import fundings from './pages/Fundings/fundings';
import companyDetailPage from './pages/Jobmarket/companyDetailPage';
import deactivateJobOffers from './pages/Jobmarket/deactivateJobOffers';
import invoices from './pages/Jobmarket/invoices';
import jobOffers from './pages/Jobmarket/jobOffers';
import manageCompanies from './pages/Jobmarket/manageCompanies';
import manageJobOffers from './pages/Jobmarket/manageJobOffers';
import manageJobmarketSettings from './pages/Jobmarket/manageJobmarketSettings';
import myJobOffers from './pages/Jobmarket/myJobOffers';
import studentJobOffers from './pages/Jobmarket/studentJobOffers';
import leihbar from './pages/LeihBar/leihbar';
import leihbarMailSettings from './pages/LeihBar/leihbarMailSettings';
import leihbarOpeningHoursSettings from './pages/LeihBar/leihbarOpeningHoursSettings';
import jobOfferingNotification from './pages/Messaging/jobOfferingNotifications';
import systemNotificationsSettings from './pages/Messaging/systemNotificationsSettings';
import polyas from './pages/Polyas/polyas';
import pricingslots from './pages/PricingTable/pricingslots';
import shibUserList from './pages/Users/shibUserList';
import watchlist from './pages/Watchlist/watchlist';
import articleDetail from './pages/articleDetail';
import articleMessagesSettings from './pages/articleMessagesSettings';
import articles from './pages/articles';
import calendar from './pages/calendar';
import chat from './pages/chat';
import home from './pages/home';
import internationalOffice from './pages/internationalOffice';
import ioSettings from './pages/ioSettings';
import listingDetail from './pages/listingDetail';
import listings from './pages/listings';
import login from './pages/login';
import managePermissionsSettings from './pages/managePermissionsSettings';
import profile from './pages/profile';
import tileSettings from './pages/tileSettings';
import validation from './validation';

const de = {
  validation,
  services: {
    jobmarket: 'Stellenmarkt',
    userservice: 'Benutzerverwaltung',
    articles: 'Beiträge/Kalender',
    bulletinBoard: 'Schwarzes Brett',
    permissionProvider: 'Rechteverwaltung',
    ioservice: 'International Office',
    messaging: 'Benachrichtigungen',
    notifications: 'Mailservice',
    faculty: ' Faculty',
    campusservice: 'Campus',
    timetableservice: 'Stundenplan',
    modules: 'Modulkatalog',
    moduleSelections: 'Modulwahl',
    unkownService: 'Unbekannt'
  },
  warnings: {
    serviceNotAvailable: 'Dieser Service steht gerade leider nicht zur Verfügung.'
  },
  pages: {
    home,
    deactivateJobOffers,
    studentJobOffers,
    login,
    manageCompanies,
    jobOffers,
    articles,
    articleDetail,
    manageJobOffers,
    companyDetailPage,
    myJobOffers,
    manageJobmarketSettings,
    listings,
    calendar,
    managePermissionsSettings,
    listingDetail,
    invoices,
    billingCustomer: customer,
    billingSettings: settings,
    billingFinance,
    articleMessagesSettings,
    profile,
    internationalOffice,
    ioSettings,
    shibUserList,
    polyas,
    systemNotificationsSettings,
    jobOfferingNotification,
    modules,
    moduleSelections,
    moduleSelectionsDetail,
    moduleSelectionLottery,
    groupings,
    selectionNotifications,
    studentView,
    roles,
    permissions,
    accessHandler,
    events,
    eventSettings,
    pricingslots,
    activityLog,
    leihbar,
    leihbarMailSettings,
    leihbarOpeningHoursSettings,
    fundings,
    fundingcategories,
    entitlementGroups,
    entitlements,
    tileSettings,
    watchlist,
    chat,
    billing: invoice
  },
  authorization: {
    notAuthorizedRoute: 'Sie verfügen nicht über die benötigten Rechte um diese Route aufzurufen.'
  },
  common: {
    or: 'Oder',
    add: 'Hinzufügen',
    select: 'Auswählen',
    copied: 'Kopiert',
    createdAt: 'Erstellt am',
    updatedAt: 'Bearbeitet am',
    throName: 'Technische Hochschule Rosenheim',
    companiesAndPartners: 'Unternehmen & Partner',
    email: 'E-Mail-Adresse',
    email_short: 'E-Mail',
    email_login: 'E-Mail/Login',
    enterEmail: 'Bitte Email eingeben',
    enterSearchTerm: 'Bitte geben Sie einen Suchbegriff ein',
    invoiceEmail: 'Rechnungsemail',
    password: 'Passwort',
    upload: 'Hochladen',
    confirmPassword: 'Passwort bestätigen',
    address: 'Adresse',
    phone: 'Telefon',
    fax: 'Fax',
    position: 'Position',
    faculty: 'Fakultät',
    faculties: 'Fakultäten',
    ok: 'Ok',
    companyName: 'Firmenname',
    name: 'Name',
    firstName: 'Vorname',
    lastName: 'Nachname',
    street: 'Straße',
    zip: 'PLZ',
    city: 'Stadt',
    useSameAddress: 'Die Firmenadresse als Rechnungsadresse nutzen',
    invoiceAddress: 'Rechnungsadresse',
    homepage: 'Homepage',
    country: 'Land',
    taxId: 'Umsatzsteueridentifikationsnummer',
    taxNumber: 'Steuernummer',
    validatingTaxId: 'Ihre Ust-IdNr. wird überprüft. Bitte haben Sie einen Moment Geduld.',
    failedValidatingTaxId: 'Die Validierung Ihrer Ust-IdNr. schlug fehl! Grund: {{cause}}',
    taxId_short: 'Ust-IdNr.',
    contactPerson: 'Ansprechpartner',
    description: 'Beschreibung',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    copy: 'Kopieren',
    reallyDelete: 'Wirklich löschen?',
    cancelEvent: 'Absagen',
    edit: 'Bearbeiten',
    register: 'Anmelden',
    unregister: 'Abmelden',
    details: 'Details',
    unlock: 'Freischalten',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    archive: 'Archivieren',
    ban: 'Bannen',
    reject: 'Abweisen',
    reactivate: 'Reaktivieren',
    course: 'Studiengang',
    courses: 'Studiengänge',
    type: 'Typ',
    chooseACountry: 'Wähle ein Land',
    emptyList:
      'Keine Einträge vorhanden. Vielleicht müssen Sie die Filtereinstellungen bearbeiten.',
    create: 'Erstellen',
    export: 'Exportieren',
    company: 'Firma',
    companies: 'Firmen',
    requiredFields: 'erforderliche Angaben',
    back: 'Zurück',
    next: 'Weiter',
    confirm: 'Bestätigen',
    period: 'Anzeigezeitraum',
    pastPeriods: 'Vergangene Anzeigezeiträume',
    start: 'Anfang',
    end: 'Ende',
    jobmarketAdministrator: 'Stellenverwalter',
    incomingsAdministrator: 'Incomingsverwalter',
    incomingsUser: 'International Office Student',
    yes: 'Ja',
    no: 'Nein',
    confirmCancel: 'Wirklich abbrechen?',
    cancelConfirm: {
      message: 'Änderungen gehen dadurch verloren. Möchten Sie diese wirklich verwerfen?',
      title: 'Wirklich abbrechen?'
    },
    title: 'Titel',
    search: 'Suche',
    genericError: 'Oh, hier ist etwas schief gelaufen. Bitte versuchen Sie es später nochmal.',
    inactive: 'Inaktiv',
    event: 'Veranstaltung',
    id: 'ID',
    userId: 'BenutzerID',
    download: 'Herunterladen',
    import: 'Importieren',
    loginWithEntitlements: 'Mit o.g. Rechten einloggen',
    subject: 'Betreff',
    html: 'HTML',
    text: 'Text',
    department: 'Abteilung',
    semester: 'Semester',
    degree: 'Grad',
    locationOfStudy: 'Studienort',
    location: 'Standort',
    shorthand: 'Kürzel',
    loading: 'Lade...',
    actions: 'Aktionen',
    on: 'An',
    off: 'Aus',
    last24h: 'Letzte 24 Stunden',
    last3d: 'Letzte 3 Tage',
    last7d: 'Letzte 7 Tage',
    last14d: 'Letzte 14 Tage',
    sortBy: 'Sortieren nach',
    category: 'Kategorie',
    clone: 'Klonen',
    none: 'Keine',
    informationUnavailable: 'Diese Information ist nicht verfügbar.',
    tooManyImages: 'Es kann maximal ein Bild hochgeladen werden.',
    weekdays: {
      mon: 'Montag',
      tue: 'Dienstag',
      wed: 'Mittwoch',
      thu: 'Donnerstag',
      fri: 'Freitag',
      sat: 'Samstag',
      sun: 'Sonntag'
    },
    weekdaysShort: {
      mon: 'Mo',
      tue: 'Di',
      wed: 'Mi',
      thu: 'Do',
      fri: 'Fr',
      sat: 'Sa',
      sun: 'So'
    },
    storno: 'Stornieren',
    canceled: 'Storniert',
    alerts: {
      failedImageUpload: 'Das Bild konnte nicht hochgeladen werden.',
      failedFileUpload: 'Die Datei konnte nicht hochgeladen werden.',
      failedFileUploadWithCause: 'Die Datei konnte nicht hochgeladen werden. Grund: {{cause}}',
      causes: {
        tooManyTokens: 'Die Datei ist zu groß.'
      }
    },
    mtrNumber: 'Matrikelnummer',
    filter: 'Filter',
    apply: 'Anwenden',
    notAvailableYet: 'Noch nicht verfügbar',
    notAvailable: 'Nicht gesetzt',
    unavailable: 'Nicht verfügbar',
    netto: 'Netto',
    brutto: 'Brutto',
    ust: 'Umsatzsteuer',
    state: 'Status',
    customer: 'Kunde',
    bankAccount: 'Bankkonto',
    paymentTarget: 'Zahlungsziel',
    tax: 'Steuerliches',
    amount: 'Anzahl',
    price: 'Preis',
    singlePrice: 'Einzelpreis',
    totalPrice: 'Gesamtpreis',
    addUser: 'Benutzer hinzufügen',
    unit: 'Einheit',
    days: 'Tage',
    close: 'Schließen',
    date: 'Datum',
    areaCurrentlyDisabled: 'Dieser Bereich ist aktuell deaktiviert.',
    preview: 'Vorschau',
    accept: 'Akzeptieren',
    deny: 'Ablehnen',
    general: 'Allgemein',
    noPermission: 'Keine Berechtigung',
    expires: 'Läuft ab am'
  },
  layout
};

export default de;
export type Translation = typeof de;
